import React from 'react';
import styles from './styles.module.scss';
import { markdownToHtml } from '@/utils/markdown-to-html';
import sanitizeHtml from 'sanitize-html';

interface H6Props {
  text: string;
  maxLines?: number;
  className?: string;
  style?: React.CSSProperties;
}

export const H6: React.FC<H6Props> = ({
  text,
  maxLines = 10000,
  className = '',
  style,
}) => {
  const clampStyle: React.CSSProperties = {
    WebkitLineClamp: maxLines,
  };
  const html = markdownToHtml(text);
  const safeHtml = sanitizeHtml(html, {
    allowedTags: ['span', 'bold', 'italic', 'strong', 'em', 'a'],
  });
  return (
    <h6
      className={`${styles.h6} ${className}`}
      style={{ ...clampStyle, ...style }}
      dangerouslySetInnerHTML={{ __html: safeHtml }}
    />
  );
};
